<template>
  <h1 class="display-4">
    <slot/>
  </h1>
  <hr>
</template>
